import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface PropertyDescriptionProps {
  description: string;
  setDescription: (value: string) => void;
}

export function PropertyDescription({
  description,
  setDescription,
}: PropertyDescriptionProps) {
  return (
    <div className="space-y-2">
      <Label htmlFor="description">Descrição</Label>
      <Textarea
        id="description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        placeholder="Descreva o imóvel..."
        className="h-32"
      />
    </div>
  );
}